import { type ReactElement } from 'react';
import { useRouter } from 'next/router';
import { type RootLayoutProps } from '@/layout/types';
import { useIsInExternalPlatform } from '@/shared/externalPlatform';
import { Conditional } from '@/shared/googleClassroom';
import { GnbHeaderForExternalPlatform } from './Header/GnbHeaderForExternalPlatform';
import { GnbHeaderForGoogleClassroom } from './Header/GnbHeaderForGoogleClassroom';
import { ProductHeader } from './Header/ProductHeader';
import { PromotionHeader } from './Header/PromotionHeader';

// '/board' 는 정확히 일치할 때만 — prefix 로 두면 '/board/new', '/board/[boardId]'
// 같은 실제 제품 페이지까지 프로모션 헤더로 잘못 잡힌다(ZEP-BOARD-LANDING 리뷰).
const PROMOTION_HEADER_EXACT_PATHS = ['/', '/board'];
const PROMOTION_HEADER_PREFIX_PATHS = ['/landing', '/pricing', '/biz'];

// export: '/board' 를 exact/prefix 중 어디에 두느냐가 이 파일의 핵심 리그레션
// 포인트라 렌더링 없이 이 판정 함수 자체를 테스트로 고정한다(getRootLayout.test.ts).
export const isPromotionHeaderPath = (pathname: string) => PROMOTION_HEADER_EXACT_PATHS.includes(pathname) || PROMOTION_HEADER_PREFIX_PATHS.some(path => pathname.startsWith(path));
const RootLayout = (props: RootLayoutProps) => {
  const isInExternalPlatform = useIsInExternalPlatform();
  const router = useRouter();
  const Header = isPromotionHeaderPath(router.pathname) ? PromotionHeader : ProductHeader;
  return <>
      {isInExternalPlatform ? <GnbHeaderForExternalPlatform /> : <Conditional inGoogleClassroom={<GnbHeaderForGoogleClassroom />}>
          <Header />
        </Conditional>}
      {props.children}
    </>;
};
export function getRootLayout(page: ReactElement) {
  return <RootLayout data-sentry-element="RootLayout" data-sentry-component="getRootLayout" data-sentry-source-file="getRootLayout.tsx">{page}</RootLayout>;
}
export function getLightLayout(page: ReactElement) {
  return <RootLayout data-sentry-element="RootLayout" data-sentry-component="getLightLayout" data-sentry-source-file="getRootLayout.tsx">{page}</RootLayout>;
}